import React, { FC } from 'react'
import { graphql, useFragment } from 'react-relay'

import {
  Column,
  PresentationCard,
  Grid,
  Stack,
  useBreakpoint,
} from '@components'

import { INITIAL_COUNTS } from './HomeScreen'

import { HomeScreenPresentationsList_query$key } from './__generated__/HomeScreenPresentationsList_query.graphql'

export const HomeScreenPresentationsList: FC<{
  query: HomeScreenPresentationsList_query$key
}> = ({ query }) => {
  const data = useFragment(
    graphql`
      fragment HomeScreenPresentationsList_query on Query {
        presentations(first: 4, orderBy: [CREATED_AT_DESC, ID_ASC]) {
          edges {
            node {
              id

              ...PresentationCard_presentation
            }
          }
        }
      }
    `,
    query
  )

  const breakpoint = useBreakpoint()

  if (!data || !data.presentations || data.presentations.edges.length === 0) {
    return null
  }

  if (breakpoint === 0) {
    return (
      <Stack gap={4}>
        {data.presentations.edges.slice(0, 4).map((edge) => (
          <PresentationCard
            key={edge.node.id}
            presentation={edge.node}
            titleNumberOfLines={2}
            numberOfLines={8}
          />
        ))}
      </Stack>
    )
  }

  return (
    <Stack gap={4}>
      <Stack>
        <Grid gap={4}>
          {data.presentations.edges
            .slice(0, INITIAL_COUNTS[breakpoint])
            .map((edge) => {
              return (
                <Column key={edge.node.id}>
                  <PresentationCard
                    presentation={edge.node}
                    titleNumberOfLines={2}
                    numberOfLines={8}
                    expand
                  />
                </Column>
              )
            })}

          {Array.from({
            length:
              INITIAL_COUNTS[breakpoint] -
              (data.presentations.edges.length || 0),
          }).map((_, index) => (
            <Column key={index} />
          ))}
        </Grid>
      </Stack>
    </Stack>
  )
}
